const routeMap = {
  CITY: '/city/:slug/:id/:period?/:category?',
  ARTIST: '/artist/:slug/:id',
  LOCATION: '/location/:slug/:id/:period?',
  LISTING_PAGE: '/listing/:slug/:id/:hash',
  EVENT_PAGE: '/event/:eventSlug/:eventId',
  ADD_EVENT: '/event/add',
  TAG: '/tags/:slug/:id',
  GROUP: '/events/:id/:slug',
  EVENT_TYPE_PAGE: {
    as: '/event/:eventSlug/:eventTypeSlug/:eventId/:eventTypeId',
    href: '/event-type/:eventSlug/:eventTypeSlug/:eventId/:eventTypeId',
  },
  SELL: '/sell/:eventId?',
  SELL_EVENT: {
    as: '/sell/event/:eventId?',
    href: '/sell/redirect',
  },
  EVENT: '/sell/:draftId/event',
  CREATE_EVENT: '/sell/:draftId/create-event/:eventTitle?',
  RESELL: '/sell/:draftId/resell',
  RESELL_TICKETS: '/sell/:draftId/resell/tickets',
  FILES: '/sell/:draftId/files',
  TICKET_INFO: '/sell/:draftId/ticket-info',
  LISTING: '/sell/:draftId/original-price',
  SELLING_PRICE: '/sell/:draftId/selling-price',
  SOCIAL: '/sell/:draftId/social',
  AVATAR: '/sell/:draftId/avatar',
  PRIVATE: '/sell/:draftId/private',
  PRIVATE_VERIFIED: '/sell/:draftId/private/verified',
  PHONE_DETAILS: '/sell/:draftId/phone-details',
  PHONE_VERIFY: '/sell/:draftId/phone-verify',
  PAYOUT_INFORMATION: '/sell/:draftId/payout-information',
  PAYOUT_CREDIT_CARD: '/sell/:draftId/payout-credit-card',
  VERIFY_IDENTITY: '/sell/:draftId/verify-identity',
  SUMMARY: '/sell/:draftId/summary',
  CONFIRM_VERIFIED: '/sell/:draftId/confirm/verified',
  PUBLISH: '/sell/:draftId/publish',
  PUBLISHED: '/sell/:draftId/published',
  CART: '/cart',
  PENDING_COUNTRY: '/checkout/country',
  PENDING_EMAIL: '/checkout/email',
  PENDING_PHONE: '/checkout/phone',
  PENDING_PHONE_VERIFY: '/checkout/phone/verify',
  PENDING_PAYMENT: '/checkout/summary',
  PENDING_PAYMENT_METHOD: '/checkout/payment/method',
  PENDING_BANK: '/checkout/payment/bank',
  PENDING_CREDIT_CARD: '/checkout/payment/card',
  PENDING_EMAIL_VERIFICATION: '/checkout/summary',
  CHECKOUT_SUMMARY: '/checkout/summary',
  FAILED_PAYMENT: '/checkout/summary',
  SUCCESSFUL_PAYMENT: '/checkout/done/:hash',
  PROCESSING_PAYMENT: '/checkout/payment',
  CANCELLED_PAYMENT: '/checkout/summary',
  PARTNERS: '/partners',
  ORGANIZERS_DASHBOARD: '/organizers/dashboard',
  CONTENT: {
    as: '/content/:slug',
    href: '/content/page/:slug',
  },
  HOW_DOES_IT_WORK: '/how-does-it-work',
  HELP: '/help',
  HELP_CONTACT: '/help/contact',
  HELP_ITEM: '/help/item/:id',
  HELP_CATEGORY: {
    as:
      '/help/:category(general|safety_and_validity|uploading_and_selling_tickets|buying_tickets|notifications|payments|listing|account)',
    href: '/help/category/:category',
  },
  HELP_COLLECTION: {
    as: '/help/contact/:collection',
    href: '/help/contact/collection/:collection',
  },
  HELP_FORM: '/help/contact/form',
  HOME: '/',
  LOGIN: '/login',
  SEARCH: '/search',
  PROFILE_FOR_SALE: '/tickets/for-sale',
  PROFILE_FOR_SALE_LISTING: {
    as: '/tickets/for-sale/:id/:hash',
    href: '/tickets/for-sale/listing/:id/:hash',
  },
  BLOG: '/blog',
  BLOG_POST: {
    as: '/blog/:slug',
    href: '/blog/post/:slug',
  },
  CATEGORY: {
    as:
      '/:slug(festivals|concerts|clubs|sports|theatre-and-comedy|vouchers-and-day-out)',
    href: '/category/:slug',
  },
  PROFILE: '/account',
  PAYOUTS: '/payouts',
  CONVERSATIONS: '/conversations',
  CONVERSATION: {
    as: '/conversations/:id',
    href: '/conversations/conversation/:id',
  },
  PROFILE_VERIFY_IDENTITY: '/account/identity/verify',
  EMAIL_EDIT: '/account/email',
  CHANGE_PAYOUT_INFO: '/account/payout-information',
  REMOVE: '/account/remove',
  BOUGHT_TICKETS: '/tickets/purchased',
  TICKET_ALERTS: '/ticket-alerts',
  TICKET_ALERT: '/ticket-alert/:id',
  ARTISTS_YOU_FOLLOW: '/artists-you-follow',
  ORGANIZER_SHOP: '/organizer-tickets/products/:shopId',
  ORGANIZER_PRODUCT: '/organizer-tickets/checkout/:productId',
  ORGANIZER_ORDER: '/organizer-tickets/order/completed/:orderId',
  VOUCHERS: '/vouchers',
  VOUCHERS_SELL: '/vouchers/sell',
  VOUCHERS_CATEGORY: {
    as: '/vouchers/:category',
    href: '/vouchers/category/:category',
  },
  VOUCHER: '/voucher/:id',
  VOUCHER_SELL_COMPLETED: '/vouchers/sell/completed/:id',
  RESERVATION: '/reservation/:id',
  BROWSE: '/browse/:period?',
  UNSUBSCRIBE: '/unsubscribe/:token',
  UNSUBSCRIBE_FEEDBACK: '/unsubscribe/feedback',
}

module.exports = {
  routeMap,
}
